// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import ChevronDown20 from './ChevronDown20';
import ChevronDown24 from './ChevronDown24';
import ChevronDown40 from './ChevronDown40';
import ChevronDown48 from './ChevronDown48';

type ChevronDownProps = {
    variation: '20' | '24' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    ChevronDown20,
    ChevronDown24,
    ChevronDown40,
    ChevronDown48,
};

const ChevronDown: FC<ChevronDownProps> = ({ variation, ...props }) => {
    const variationKey = `ChevronDown${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"ChevronDown" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default ChevronDown;
